var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { MetricTarget } from '../../enum';
export var SUMMARY_DATA_ROWS = {
  forecastedDemand: 'forecastedDemand',
  weightedAht: 'weightedAht',
  targetProductivity: 'targetProductivity',
  forecastedSl: 'forecastedSl',
  forecastedAnswerSpeed: 'forecastedAnswerSpeed',
  maxOccupancy: 'maxOccupancy',
  forecastedOccupancy: 'forecastedOccupancy',
  forecastedAbandonmentRate: 'abandonmentRate',
  totalWorkloadHours: 'totalWorkloadHours',
  productionHours: 'productionHours',
  productiveFte: 'productiveFte',
  fteAgents: 'fteAgents',
  headcountAgents: 'headcountAgents'
};
export var PERCENTAGES = ['targetProductivity', 'forecastedSl', 'maxOccupancy', 'forecastedOccupancy', 'forecastedAbandonmentRate'];
export var ONE_DECIMAL_SUMMARY = {
  fteAgents: 1,
  productiveFte: 1,
  forecastedAbandonmentRate: 1
};
export var MULTISKILL_LABELS = ['occupancy'];
// Order must match backend DAILY_REPORT_COLUMNS: work volume, production FTE, required FTE, service level, ASA, occupancy, abandonment rate
export var DETAIL_LABELS = ['workVolume', 'productionFte', 'requiredFte', 'serviceLevel', 'asa', 'occupancy', 'abandonmentRate'];
export var DETAIL_LABEL_INDEX = {
  workVolume: 0,
  productionFte: 1,
  requiredFte: 2,
  serviceLevel: 4,
  asa: 5,
  occupancy: 6,
  abandonmentRate: 7
};
export var PERCENTAGES_DETAIL = ['serviceLevel', 'occupancy', 'abandonmentRate'];
export var PERCENTAGES_DETAIL_INDEX = [3, 4, 7, 8, 9, 10];
// Percentage columns use decimal={1} in detailTable (with PERCENTAGES_DETAIL) so SL/occupancy/abandonment show one fractional digit.
export var ONE_DECIMAL_DETAIL = __spreadArray(['staffRequired'], PERCENTAGES_DETAIL, true);
export var ONE_DECIMAL_DETAIL_INDEX = __spreadArray([1, 2], PERCENTAGES_DETAIL_INDEX, true);
export var ADJUSTED_COLOR = '#695649';
export var metricTargetMap = {
  forecastedAnswerSpeed: MetricTarget.ASA,
  forecastedOccupancy: MetricTarget.Occupancy,
  forecastedSl: MetricTarget.ServiceLevel
};
export var FLAG = ' \u2691';
// Constant for closed queue indicator
export var CLOSED_INDICATOR = '-';
// Production Hours specific labels and configurations
export var PROD_HOURS_LABELS = ['productiveHours', 'productionHours', 'productionFte', 'requiredFte', 'seatsRequired'];
export var PROD_HOURS_LABELS_WITHOUT_PRODUCTIVE = ['productionHours', 'productionFte', 'requiredFte', 'seatsRequired'];
export var PROD_HOURS_LABEL_INDEX = {
  productiveHours: 0,
  productionHours: 1,
  productionFte: 2,
  requiredFte: 3,
  seatsRequired: 5
};
export var PROD_HOURS_HOURS_INDICES = [0, 1];
export var SINGLE_QUEUE_ONLY_CHART_METRICS = new Set(['workVolume', 'serviceLevel', 'asa', 'occupancy', 'abandonmentRate']);
export var MULTI_QUEUE_FALLBACK_CHART_METRIC = 'productionFte';